export default __webpack_public_path__ + "static/line-with-gaps-50c87b66e0c6cc745e70f0af0804314d.png";